// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-billing-accounts-page{
    margin: 0px;
    padding: 0px;
    height: 100vh;
    box-sizing: border-box;
    font-family:Verdana, Geneva, Tahoma, sans-serif;
}
.tenant-administrator-billing-accounts-page-layout{
    height: 90%;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: auto 1fr;
}
.tenant-administrator-billing-accounts-parent-container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.tenant-administrator-billing-accounts-container{
    width: 90%;
    height: 85%;
    padding: 2% 3%;
    border-radius: 5px;
    position: relative;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-billing-accounts-header-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.tenant-administrator-billing-accounts-header-container h2{
    font-weight: lighter;
    color: rgb(90, 90, 90);
}
.tenant-administrator-billing-accounts-body-container{
    overflow: auto;
    height: 71.5vh;
    position: relative;
    box-sizing: border-box;
}
.tenant-administrator-billing-accounts-body-container table{
    width: 100%;
    border-collapse: collapse;
}
.tenant-administrator-billing-accounts-body-container table tr{
    cursor: pointer;
}
.tenant-administrator-billing-accounts-body-container table th,
.tenant-administrator-billing-accounts-body-container table td{
    font-size: 15px;
    text-align: left;
    white-space: nowrap;
}
.tenant-administrator-billing-accounts-body-container table th{
    font-weight: 500;
    padding: 10px 5px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-billing-accounts-body-container table td{
    padding: 10px 5px;
}
#tenant-administrator-billing-accounts-table-header-row{
    background-color: transparent;
}
.tenant-administrator-billing-accounts-body-container table tr:nth-child(odd){
    background-color: rgba(206, 206, 206, 0.953);
}
.tenant-administrator-billing-accounts-body-container table tr:nth-child(even){
    background-color: rgb(242, 242, 242);
}
.tenant-administrator-loading-billing-accounts-mask-container{
    height: 100%;
}
.tenant-administrator-loading-billing-accounts-mask{
    height: 80%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.tenant-administrator-loading-billing-accounts-mask-spinner{
    height: 40px;
    width: 40px;
    border: 2px solid brown;
    border-top-color: transparent;
    border-radius: 50%;
    animation: tenant-administrator-loading-billing-accounts-mask-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-loading-billing-accounts-mask-spinner {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/BillingAccounts/BillingAccounts.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,+CAA+C;AACnD;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;AAC1C;AACA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;;IAEI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4DAA4D;AAChE;AACA;IACI,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,4CAA4C;AAChD;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,0FAA0F;AAC9F;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".tenant-administrator-billing-accounts-page{\r\n    margin: 0px;\r\n    padding: 0px;\r\n    height: 100vh;\r\n    box-sizing: border-box;\r\n    font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n}\r\n.tenant-administrator-billing-accounts-page-layout{\r\n    height: 90%;\r\n    box-sizing: border-box;\r\n    display: grid;\r\n    grid-template-columns: auto 1fr;\r\n}\r\n.tenant-administrator-billing-accounts-parent-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.tenant-administrator-billing-accounts-container{\r\n    width: 90%;\r\n    height: 85%;\r\n    padding: 2% 3%;\r\n    border-radius: 5px;\r\n    position: relative;\r\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\r\n}\r\n.tenant-administrator-billing-accounts-header-container{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.tenant-administrator-billing-accounts-header-container h2{\r\n    font-weight: lighter;\r\n    color: rgb(90, 90, 90);\r\n}\r\n.tenant-administrator-billing-accounts-body-container{\r\n    overflow: auto;\r\n    height: 71.5vh;\r\n    position: relative;\r\n    box-sizing: border-box;\r\n}\r\n.tenant-administrator-billing-accounts-body-container table{\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n.tenant-administrator-billing-accounts-body-container table tr{\r\n    cursor: pointer;\r\n}\r\n.tenant-administrator-billing-accounts-body-container table th,\r\n.tenant-administrator-billing-accounts-body-container table td{\r\n    font-size: 15px;\r\n    text-align: left;\r\n    white-space: nowrap;\r\n}\r\n.tenant-administrator-billing-accounts-body-container table th{\r\n    font-weight: 500;\r\n    padding: 10px 5px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-billing-accounts-body-container table td{\r\n    padding: 10px 5px;\r\n}\r\n#tenant-administrator-billing-accounts-table-header-row{\r\n    background-color: transparent;\r\n}\r\n.tenant-administrator-billing-accounts-body-container table tr:nth-child(odd){\r\n    background-color: rgba(206, 206, 206, 0.953);\r\n}\r\n.tenant-administrator-billing-accounts-body-container table tr:nth-child(even){\r\n    background-color: rgb(242, 242, 242);\r\n}\r\n.tenant-administrator-loading-billing-accounts-mask-container{\r\n    height: 100%;\r\n}\r\n.tenant-administrator-loading-billing-accounts-mask{\r\n    height: 80%;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.tenant-administrator-loading-billing-accounts-mask-spinner{\r\n    height: 40px;\r\n    width: 40px;\r\n    border: 2px solid brown;\r\n    border-top-color: transparent;\r\n    border-radius: 50%;\r\n    animation: tenant-administrator-loading-billing-accounts-mask-spinner 0.8s linear infinite;\r\n}\r\n@keyframes tenant-administrator-loading-billing-accounts-mask-spinner {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
